import React, { FC, useMemo } from 'react';

type Variant = 'default' | 'small' | 'medium' | 'intro';
type Color = 'dark' | 'darker' | 'light' | 'lighter';

export type ParagraphProps = {
  children?: React.ReactNode;
  /**
   * Variant to define the button style
   */
  variant?: Variant;
  /**
   * Color to define the button style
   */
  color?: Color;
  marginBottom?: number;
  mdMarginBottom?: number;
};

const BASE_PARAGRAPH_CLASSES = ['font-sans'];
const DEFAULT_PARAGRAPH_CLASSES = ['font-regular', 'leading-4'];
const MEDIUM_PARAGRAPH_CLASSES = ['font-regular', 'text-xs', 'leading-3'];
const SMALL_PARAGRAPH_CLASSES = ['font-medium', 'text-2xs', 'leading-2'];
const INTRO_PARAGRAPH_CLASSES = ['font-regular', 'text-lg', 'leading-6'];

export const Paragraph: FC<ParagraphProps> = ({
  children = 'This is a paragraph',
  variant = 'default',
  color = 'darker',
  marginBottom,
  mdMarginBottom,
}: ParagraphProps) => {
  const className = useMemo(() => {
    const classes = BASE_PARAGRAPH_CLASSES;

    switch (color) {
      case 'dark':
        if (variant !== 'default') {
          classes.push('text-gray-600');
        } else {
          classes.push('text-gray-700');
        }
        break;
      case 'darker':
        classes.push('text-gray-700');
        break;
      case 'light':
        if (variant !== 'default') {
          classes.push('text-gray-300');
        } else {
          classes.push('text-white');
        }
        break;
      case 'lighter':
        classes.push('text-white');
        break;
    }

    if (marginBottom) {
      classes.push(`mb-${marginBottom}`);
    }
    if (mdMarginBottom) {
      classes.push(`md:mb-${mdMarginBottom}`);
    }

    switch (variant) {
      case 'small':
        classes.push(...SMALL_PARAGRAPH_CLASSES);
        break;
      case 'medium':
        classes.push(...MEDIUM_PARAGRAPH_CLASSES);
        break;
      case 'intro':
        classes.push(...INTRO_PARAGRAPH_CLASSES);
        break;
      default:
        classes.push(...DEFAULT_PARAGRAPH_CLASSES);
    }

    return classes.join(' ');
  }, [variant, color, marginBottom, mdMarginBottom]);
  return <p className={className}>{children}</p>;
};
